"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Project/App Name APIs — v1
 * API v1 documentation for the backend services of Project/App Name
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfTeamsGroupDto = instanceOfTeamsGroupDto;
exports.TeamsGroupDtoFromJSON = TeamsGroupDtoFromJSON;
exports.TeamsGroupDtoFromJSONTyped = TeamsGroupDtoFromJSONTyped;
exports.TeamsGroupDtoToJSON = TeamsGroupDtoToJSON;
exports.TeamsGroupDtoToJSONTyped = TeamsGroupDtoToJSONTyped;
var TeamItemDto_1 = require("./TeamItemDto");
/**
 * Check if a given object implements the TeamsGroupDto interface.
 */
function instanceOfTeamsGroupDto(value) {
    if (!('sportId' in value) || value['sportId'] === undefined)
        return false;
    if (!('sportName' in value) || value['sportName'] === undefined)
        return false;
    if (!('items' in value) || value['items'] === undefined)
        return false;
    return true;
}
function TeamsGroupDtoFromJSON(json) {
    return TeamsGroupDtoFromJSONTyped(json, false);
}
function TeamsGroupDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'sportId': json['sportId'],
        'sportName': json['sportName'],
        'items': (json['items'].map(TeamItemDto_1.TeamItemDtoFromJSON)),
    };
}
function TeamsGroupDtoToJSON(json) {
    return TeamsGroupDtoToJSONTyped(json, false);
}
function TeamsGroupDtoToJSONTyped(value, ignoreDiscriminator) {
    if (ignoreDiscriminator === void 0) { ignoreDiscriminator = false; }
    if (value == null) {
        return value;
    }
    return {
        'sportId': value['sportId'],
        'sportName': value['sportName'],
        'items': (value['items'].map(TeamItemDto_1.TeamItemDtoToJSON)),
    };
}
